import React from "react";

import { DiaryType } from "../../../../../components/DiaryCalendar";
import { TaskBadgeDay } from "./Day";
import { TaskBadgeMonth } from "./Month";
import { TaskBadgeProps } from "./types";
import { TaskBadgeWeek } from "./Week";

const TaskBadge = (props: TaskBadgeProps) => {
  const { viewMode } = props;

  switch (viewMode) {
    case DiaryType.MONTH:
      return <TaskBadgeMonth {...props} />;
    case DiaryType.DAY:
      return <TaskBadgeDay {...props} />;
    case DiaryType.WEEK:
      return <TaskBadgeWeek {...props} />;
    default:
      return <TaskBadgeDay {...props} />;
  }
};

export default TaskBadge;
